import axios from "axios";
import { baseUrl, LOGIN } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";

/** Keeps the existing POST request and response contract. */
export function postRequest1(data) {
  return axios.post(`${baseUrl}/${LOGIN}`, data, configReq());
}

/** Keeps the existing POST request and response contract. */
export function postRequest2(data) {
  return axios.post(`${baseUrl}/${LOGIN}`, data, configReq());
}
